import { useQueryClient } from '@tanstack/react-query'
import { useUpdateFacilityConfig } from '../index.js'
import { DEFAULT_FACILITY_CONFIG } from '../index.js'
import { Settings } from 'lucide-react'
import { Button } from '../../core/index.js'

export function FacilityNotConfigured({ facilityId }: { facilityId: string }) {
  const queryClient = useQueryClient()
  const mutation = useUpdateFacilityConfig(facilityId)

  function handleSetup(): void {
    mutation.mutate(
      { facilityId, ...DEFAULT_FACILITY_CONFIG },
      {
        onSuccess: () => {
          // Every facility-scoped query (dashboard summary, tier distribution,
          // workers, config itself) 404d the same way while unconfigured -
          // refetch all of them now that config exists, regardless of which
          // page the operator set this up from.
          void queryClient.invalidateQueries({ predicate: (query) => query.queryKey[1] === facilityId })
        },
      },
    )
  }

  return (
    <div className="max-w-md mx-auto p-10 text-center flex flex-col items-center gap-4">
      <div className="w-12 h-12 rounded-full bg-marine-lt flex items-center justify-center text-marine" aria-hidden="true">
        <Settings className="h-6 w-6" />
      </div>
      <div>
        <div className="text-sm font-bold text-ink mb-1">This facility hasn't been configured yet</div>
        <p className="text-xs text-ink-mid leading-relaxed">
          Score weights, tier thresholds, and bid-window timing need to be set before this facility's dashboard and scheduling can be
          used.
        </p>
      </div>
      <Button icon={Settings} onClick={handleSetup} disabled={mutation.isPending}>
        {mutation.isPending ? 'Setting up…' : 'Set Up Default Configuration'}
      </Button>
      {mutation.isError && <span className="text-xs text-coral font-bold">Failed to set up configuration. Try again.</span>}
    </div>
  )
}
